import VehiclesReservationsTable from 'src/features/reservations/components/tables/VehiclesReservationsTable.tsx';

const Reservations = () => {
    return <VehiclesReservationsTable />;
};

export default Reservations;
